/**
 * Runtime configuration, read once from Vite's `import.meta.env`.
 *
 * Only `VITE_`-prefixed variables reach the client bundle (Vite's own
 * security boundary) — nothing here can ever leak a server secret, because
 * nothing here has access to one. Identical to apps/merchant-dashboard's
 * own env.ts.
 */
export const env = {
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? 'http://localhost:3000',
  /**
   * Where the MERCHANT space lives (e.g. `https://marchand.souk.example`): the address the hand-over sheet gives a merchant. It is not
   * this console's own host, so it cannot be guessed; local development falls back to the merchant dashboard's dev port, and a
   * production build with no value gets `null` (the sheet then says the address is missing - never a wrong one).
   */
  merchantDashboardUrl:
    (import.meta.env.VITE_MERCHANT_DASHBOARD_URL as string | undefined)?.trim() ??
    (import.meta.env.DEV ? 'http://localhost:5173' : null),
} as const;
